import React, { Component } from 'react'
import Dashboard from '../Dashboard'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import arrow_right_img from '../../utils/assets/images/arrow-right.png'
import SouscriptionSwitcher from '../../components/SouscriptionSwitcher'
import { fetchReauthenticateMembersAction } from  '../../actions/Authentification/Reauthenticate'
import {  fetchSouscripteurAction, fetchUpdateSouscripteurAction, fetchSendMailSouscripteurAction } from '../../actions/Souscription/Souscripteur'
import moment from "moment"

import {
  fetchReauthenticateCourtiersAction
} from  '../../actions/Authentification/ReauthenticateCourtiers'

class Declaration extends Component {
  state = {
    isCurrentLoginCourtier: localStorage.getItem("isCurrentLoginCourtier"),
    loading: false,
    isChecked: false,
    applyRedirect: false,
    submitSouscripteurSuccess: false
  }
  componentDidMount() {
    document.title = `Dashboard Membre | Déclaration`

    const { isCurrentLoginCourtier } = this.state
    const { getReauthenticate, reauthenticateMembers, reauthenticateCourtiers, getReauthenticateCourtiers, userGetSouscripteur } = this.props
    
    if (isCurrentLoginCourtier) {
      if (Object.keys(reauthenticateCourtiers.courtierData).length === 0) {
        getReauthenticateCourtiers()
      }

      if (reauthenticateCourtiers.courtierData.souscripteurID) {
        userGetSouscripteur(reauthenticateCourtiers.courtierData.souscripteurID)
      }else {
        getReauthenticateCourtiers()
      }
    }else {
      if (Object.keys(reauthenticateMembers.userData).length === 0) {
        getReauthenticate()
      }
      if (reauthenticateMembers.userData.souscripteurID) {
        userGetSouscripteur(reauthenticateMembers.userData.souscripteurID)
      }
    }
  }
  componentWillUpdate(nextProps, nextState) {
    const { reauthenticateMembers, reauthenticateCourtiers, userGetSouscripteur } = nextProps
    if (reauthenticateMembers.userData.length !== this.props.reauthenticateMembers.userData.length) {
      if (reauthenticateMembers.userData.souscripteurID) {
        userGetSouscripteur(reauthenticateMembers.userData.souscripteurID)
      }
    }
    if (reauthenticateCourtiers.courtierData.length !== this.props.reauthenticateCourtiers.courtierData.length) {
      if (reauthenticateCourtiers.courtierData.souscripteurID) {
        userGetSouscripteur(reauthenticateCourtiers.courtierData.souscripteurID)
      }
    }
    if (nextProps.updateSouscripteur.isSuccess !== this.props.updateSouscripteur.isSuccess)  {
      this.setState({submitSouscripteurSuccess: nextProps.updateSouscripteur.isSuccess})
    }
  }
  handleSubmittedSouscription = () => {
    this.setState({loading: true})
    
    const { isChecked, isCurrentLoginCourtier } = this.state
    const { userUpdateSouscripteur, reauthenticateMembers, reauthenticateCourtiers, userSendMailSouscripteur, getSouscripteur } = this.props

    if (isChecked) {
      if(isCurrentLoginCourtier) {
        userUpdateSouscripteur(reauthenticateCourtiers.courtierData.souscripteurID, {submitted: true, submitTime: moment().valueOf(), status: "submitted"})
        
        /*userSendMailSouscripteur({email: reauthenticateMembers.userData.email,
          subject:  capitalizeCivility + " " + reauthenticateMembers.userData.firstname + ", votre souscription SƆHU est à l’étude",
          type: "after-soumission",
          name: reauthenticateMembers.userData.lastname + " " + reauthenticateMembers.userData.firstname
        })*/
        let fromEmail = "medecin@aps-benin.com"
        let ccEmail = "medecin@aps-benin.com"
        let toEmail = getSouscripteur.souscripteurData.email + "," + reauthenticateCourtiers.courtierData.email

        userSendMailSouscripteur({
          toEmail, ccEmail, fromEmail,
          civility: "",
          firstname: getSouscripteur.souscripteurData.firstname,
          lastname: getSouscripteur.souscripteurData.lastname,
          type: "after-soumission",
        })
      }else {
        userUpdateSouscripteur(reauthenticateMembers.userData.souscripteurID, {submitted: true, submitTime: moment().valueOf(), status: "submitted"})
        
        /*userSendMailSouscripteur({email: reauthenticateMembers.userData.email,
          subject:  capitalizeCivility + " " + reauthenticateMembers.userData.firstname + ", votre souscription SƆHU est à l’étude",
          type: "after-soumission",
          name: reauthenticateMembers.userData.lastname + " " + reauthenticateMembers.userData.firstname
        })*/
        
        let fromEmail = "medecin@aps-benin.com"
        let ccEmail = "medecin@aps-benin.com"
        let toEmail = ""

        if(!reauthenticateMembers.userData.parentCode) {
          toEmail = reauthenticateMembers.userData.email + ",christian@africabrokersonline.com"
        } else {
          toEmail = reauthenticateMembers.userData.email
        }

        userSendMailSouscripteur({
          toEmail, ccEmail, fromEmail,
          civility: reauthenticateMembers.userData.civility.charAt(0).toUpperCase() + reauthenticateMembers.userData.civility.slice(1).toLowerCase(),
          firstname: getSouscripteur.souscripteurData.firstname,
          lastname: getSouscripteur.souscripteurData.lastname,
          type: "after-soumission",
        })
      }

      this.setState({applyRedirect: true, loading: true})
    }
  }
  handleCheckBox = (event) => {
    this.setState({isChecked: event.target.checked})
  }
  render() {
    const { match, reauthenticateMembers, reauthenticateCourtiers, getSouscripteur } = this.props
    const {loading, submitSouscripteurSuccess, applyRedirect, isCurrentLoginCourtier} = this.state

    return(
      <div>
        <Header userIsSuccessLogin={isCurrentLoginCourtier ? reauthenticateCourtiers.isSuccess : reauthenticateMembers.isSuccess} />
          {(getSouscripteur.souscripteurData.status === "submitted" || getSouscripteur.souscripteurData.status === "payment-pending" || (submitSouscripteurSuccess && applyRedirect)) && <Redirect to="/soumis" push/>}
          {(getSouscripteur.souscripteurData.status === "police-active" || (submitSouscripteurSuccess && applyRedirect)) && <Redirect to="/soumis" push/>}
          {(reauthenticateMembers.isLoading || reauthenticateCourtiers.isLoading)
            ?
              <div className="aps-spinner-container-loading">
                <div className="uk-spinner">
                  <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                     <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="14"></circle>
                  </svg>
                </div>
                <div className="aps-section-register-desc">chargement en cours</div>
              </div>
            :
              <Dashboard match={match}>
                <div className="aps-dashboard-menu-tab-content">
                  <SouscriptionSwitcher match={match} />
                  <div>
                    <div className="uk-text-center aps-dashboard-souscripteur-title uk-text-bold" style={{paddingBottom: "0px"}}>
                      Déclaration
                    </div>
                    <div className="aps-dashboard-declaration">
                      <div className="aps-dashboard-declaration-content">
                        <p className="uk-text-justify">
                          Je demande mon adhésion à l&apos;Association de Prévoyance Sociale
                          du Bénin ainsi qu’aux conventions SƆHU souscrites
                          par elle via son courtier (mandataire) auprès de Atlantique Assurances Bénin pour
                          les garanties frais de santé et capital décès/invalidité. Je déclare avoir
                          pris connaissance des statuts de l’Association de Prévoyance Sociale du Bénin
                          téléchargeables <Link to="https://aps-benin.com/wp-content/uploads/2019/12/APS-B%C3%A9nin_Statuts_et_R%C3%A8glement_Int%C3%A9rieur.pdf" target="_blank" className="aps-dashboard-declaration-link-pdf">ici</Link>.
                          <br />
                          <br /> Je déclare avoir lu et compris le tableau des garanties et les conditions générales du contrat d’assurance SƆHU.
                          <br />
                          <br />J&apos;accepte d’être contacté par téléphone ou par mail à propos de ma demande d’assurance et des suites données.
                          <br />
                          <br />L&apos;attention des adhérents est attirée sur le fait que la souscription au présent régime ne les dispense pas
                          des cotisations dues au régime obligatoire dont ils pourraient relever et que certaines prestations sont soumises à
                          l’application de délais d’attente.
                          <br />
                          <br /> Je soussigné(e), certifie exactes et sincères les informations renseignées dans le présent bulletin d&apos;adhésion ainsi que
                          les réponses aux questions médicales, n&apos;avoir rien déclaré ou omis de déclarer qui puisse induire en erreur l&apos;Assureur. Conformément
                          à l&apos;article 18 du code CIMA, la fausse déclaration intentionnelle est sanctionnée par la nullité du contrat. Les primes payées
                          demeurent acquises à l&apos;assureur.
                          <br /> <br />
                          J&apos;ai bien noté que :{" "}
                        </p>
                      </div>
                    </div>
                    <div className="aps-section-alerte-green-container-declaration">
                      <div
                        className="aps-section-alerte-green-container-simulation-check"
                        data-uk-grid
                      >
                        <div className="uk-width-1-6 aps-section-alerte-green-arrow-right">
                          <img src={arrow_right_img} alt="arrow-right" />
                        </div>
                        <div className="uk-width-expand aps-section-alerte-green-expand">
                          <p className="aps-section-alerte-green-content-full uk-text-bold uk-text-justify">
                            Mon contrat est à durée ferme et souscrit pour une durée de 12 mois
                          </p>
                        </div>
                      </div>

                      <div
                        className="aps-section-alerte-green-container-simulation-none"
                        data-uk-grid
                      >
                        <div className="uk-width-1-6 aps-section-alerte-green-arrow-right">
                          <img src={arrow_right_img} alt="arrow-right" />
                        </div>
                        <div className="uk-width-expand aps-section-alerte-green-expand">
                          <p className="aps-section-alerte-green-content-full uk-text-bold">
                            Délais d'attente :
                          </p>
                        </div>
                      </div>
                      <div
                        className="aps-section-alerte-green-container-simulation-none"
                        data-uk-grid
                      >
                        <div className="uk-width-1-6 aps-section-alerte-green-arrow-right" />
                        <div className="uk-width-expand aps-section-alerte-green-expand">
                          <ul className="uk-list uk-list-bullet aps-section-alerte-green-content-bullet">
                            <li>Pas de délai de carence en cas d’accident ;
                            </li>
                            <li>01 mois après la souscription pour les soins ordinaires ;
                            </li>
                            <li>06 mois pour la lunetterie et les prothèses dentaires ;
                            </li>
                            <li>06 mois pour les maladies chroniques non rachetées, non déclarées et survenant pour la première fois pendant le contrat ;
                            </li>
                            <li>09 mois pour la maternité.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <p
                        style={{paddingLeft: "8%"}}
                        className="aps-dashboard-declaration-content uk-text-justify"
                      >
                        Mon adhésion au présent contrat prend effet à la date indiquée sur le devis et au plus
                        tôt le lendemain du jour de réception par l&apos;assureur du dossier d&apos;adhésion complet
                        (bulletin d’adhésion et questionnaire médical complétés et signés, transmission des
                          informations complémentaires éventuellement demandées), sous réserve de l&apos;acceptation
                          de mon dossier par le département médical de l&apos;assureur et du paiement intégral de la
                          première cotisation (art. 13 du code CIMA).
                      </p>
                      <p
                        style={{paddingLeft: "8%"}}
                        className="aps-dashboard-declaration-content uk-text-justify"
                      >
                        En cas d'atteinte du plafond annuel ou d’un sous plafond par l’assuré et à sa demande, l’assureur
                        pourra proposer une reconstitution de garanties moyennant prime additionnelle.
                      </p>
                      {isCurrentLoginCourtier && (
                        <div
                          className="aps-section-alerte-green-container-simulation-check"
                          data-uk-grid
                        >
                          <div className="uk-width-1-6 aps-section-alerte-green-arrow-right">
                            <img src={arrow_right_img} alt="arrow-right" />
                          </div>
                          <div className="uk-width-expand aps-section-alerte-green-expand">
                            <p className="aps-dashboard-declaration-content uk-text-justify">
                              <span className="uk-text-bold">Agent </span>: 
                              j’autorise {reauthenticateCourtiers.courtierData.companyName} à agir en
                              mon nom en ce qui concerne la gestion de cette police, ce qui peut inclure la communication d’informations
                              médicales confidentielles. Cette autorisation est valide tant que je ne l’aurai pas annulée par écrit 
                              auprès de Atlantique Assurances Bénin.
                            </p>
                          </div>
                        </div>
                      )
                      }
                    </div>
                    <div className="aps-dashboard-souscription-switch">
                      <div className="aps-dashboard-declaration-termes uk-text-center" data-uk-grid>
                        <p className="uk-width-expand">
                          <input
                            style={{paddingRight: "14px"}}
                            className="uk-checkbox aps-questionnaire-answers-checkbox"
                            type="checkbox"
                            onChange={event => this.handleCheckBox(event)}
                          />{" "}
                          En cochant, j&apos;accepte les conditions de souscription ci-dessus énumérées.
                        </p>
                      </div>

                      <div className="aps-dashboard-souscription-switch-btn aps-dashboard-souscription-switch-btn-declaration aps-bottom-btn-text-position-second">
                        <Link
                          to="/data-protection"
                          className="uk-button aps-btn-silver"
                        >
                          Section précédente
                        </Link>

                        <button
                          className={`uk-button aps-btn-green aps-btn-green-dashboard-btn  ${!this.state.isChecked ? 'aps-section-register-action-btn-no-active apply-disabled-btn' : ''}`}
                          onClick={this.handleSubmittedSouscription}
                          disabled={!this.state.isChecked}
                        >{loading ? "En cours ..." : "Soumettre"}</button>
                      </div>

                    </div>
                  </div>
                </div>
                {(reauthenticateMembers.isError && !isCurrentLoginCourtier) &&
                  <div>
                    <Redirect to='/connexion' push/>
                  </div>
                }
                {(reauthenticateCourtiers.isError && !isCurrentLoginCourtier) &&
                  <div>
                    <Redirect to='/connexion-intermediaires' push/>
                  </div>
                }
              </Dashboard>
          }
        <Footer />
      </div>
    )
  }
}

const mapStateToProps = ({ reauthenticateMembers, reauthenticateCourtiers, updateSouscripteur, getSouscripteur }) => {
  return {
    reauthenticateMembers,
    reauthenticateCourtiers,
    updateSouscripteur,
    getSouscripteur
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getReauthenticate: () => dispatch(fetchReauthenticateMembersAction()),
    getReauthenticateCourtiers: () => dispatch(fetchReauthenticateCourtiersAction()),
    userGetSouscripteur: (souscripteurID) => dispatch(fetchSouscripteurAction(souscripteurID)),
    userUpdateSouscripteur: (souscripteurID, souscripteurData) => dispatch(fetchUpdateSouscripteurAction(souscripteurID, souscripteurData)),
    userSendMailSouscripteur: (emailData) => dispatch(fetchSendMailSouscripteurAction(emailData)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Declaration)



// WEBPACK FOOTER //
// ./src/containers/Declaration/index.js